var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1ComputerTabletSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.19 44h-7.37A3.87 3.87 0 0058 47.81v12.37A3.87 3.87 0 0061.81 64h7.37A3.87 3.87 0 0073 60.19V47.82A3.87 3.87 0 0069.19 44zM69 60h-7V48h7v12zm-25 0h11v4H43.81A3.87 3.87 0 0140 60.18V32.81A3.87 3.87 0 0143.82 29h18.37A3.87 3.87 0 0166 32.82V41h-4v-8H44v27zM7 50h30v4h-7v6h7v4H17v-4h9v-6H6.81A3.87 3.87 0 013 50.18V18.81A3.87 3.87 0 016.82 15h43.37A3.87 3.87 0 0154 18.82V26h-4v-7H7v31z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Computer_tablet_smartphone.09d916ca.svg";
export { SvgH1ComputerTabletSmartphone as ReactComponent };